export enum StageEnum {
  Dev2 = 'dev2',
  Preproduction = 'preproduction',
  Preprod = 'preprod',
  Production = 'production',
  Localhost = 'localhost',
}

export const getUrlStage = (hostname: string): StageEnum => {
  if (hostname.includes(`.${StageEnum.Preproduction}.`)) {
    return StageEnum.Preproduction;
  }

  if (
    hostname.includes(`.${StageEnum.Preprod}.`) ||
    hostname.includes(`.app.ixc-preprod.cdek.`)
  ) {
    return StageEnum.Preprod;
  }

  if (hostname.includes(`localhost`) || hostname.startsWith('192.168')) {
    return StageEnum.Localhost;
  }

  if (hostname.includes(`.${StageEnum.Dev2}.`)) {
    return StageEnum.Dev2;
  }

  return StageEnum.Production;
};

const apiUrlsConfig: Record<StageEnum, string> = {
  [StageEnum.Production]: '/',
  [StageEnum.Preproduction]: '/',
  [StageEnum.Preprod]: '/',
  [StageEnum.Dev2]: '/',
  localhost: '/',
};

const settingsApiUrlsConfig: Record<StageEnum, string> = {
  [StageEnum.Production]: 'https://api.cdek.ru',
  [StageEnum.Preproduction]: 'https://api.preproduction.cdek.ru',
  [StageEnum.Preprod]: 'https://api.preprod.cdek.tech',
  [StageEnum.Dev2]: 'https://api.dev2.cdek.ru',
  [StageEnum.Localhost]: 'https://api.preprod.cdek.tech',
};

const landingUrlsConfig: Record<StageEnum, string> = {
  [StageEnum.Production]: 'https://developer.cdek.ru',
  [StageEnum.Preproduction]: 'https://developer.preproduction.cdek.ru',
  [StageEnum.Preprod]: 'https://developer.preprod.cdek.tech',
  [StageEnum.Dev2]: 'https://developer.dev2.cdek.ru',
  [StageEnum.Localhost]: 'https://developer.preprod.cdek.tech',
};

export const STAGE = getUrlStage(window.location.hostname);
export const IS_PRODUCTION = STAGE === StageEnum.Production;

export const API_URL = apiUrlsConfig[STAGE] ?? '/';

export const SETTINGS_API_URL = settingsApiUrlsConfig[STAGE];
export const LANDING_URL = landingUrlsConfig[STAGE];
